export const toCamelCase = (str: string): string => {
  return str
    .replace(/([a-z])([A-Z])/g, "$1 $2") // Add space before capital letters for camelCase input
    .replace(/[\s_-]+/g, " ") // Replace spaces, underscores, and hyphens with single space
    .trim() // Remove leading/trailing whitespace
    .split(" ")
    .filter((word) => word.length > 0) // Remove empty strings
    .map((word, index) => {
      if (index === 0) {
        return word.toLowerCase();
      }
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join("");
};
